module.exports = __webpack_public_path__ + "static/media/rental-in-final-stage-img.12cc1aa7.svg";